var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid-view" }, [
    _c(
      "div",
      { staticClass: "main-content queryDetail" },
      [
        _c(
          "search-item",
          {
            key: _vm.identify,
            ref: _vm.identify,
            attrs: {
              "is-append-query": _vm.isAppendQuery,
              "show-more-scheme": true,
              "show-simple": _vm.showSimple,
              "expand-adv": true,
              "search-item-code": _vm.searchItemCode,
              "config-module": _vm.configModule,
              "grid-config-module": _vm.gridConfigModule,
              "auto-init": _vm.searchItemAutoInit,
              "custom-search-items": _vm.customSearchItems,
              "custom-sim-query-placeholder": _vm.simQueryPlaceholder,
              "col-settings": _vm.colSettings
            },
            on: {
              advSearchItemCallBack: _vm.fetchData,
              simSearchItemCallBack: _vm.fetchDataBykeyWord,
              advToggle: _vm.scrollCallback,
              perConfigChange: function(value) {
                _vm.perConfigName = value
              },
              refreshGrid: function() {
                _vm.gridRefreshId += 1
              }
            }
          },
          [
            _c(
              "template",
              { slot: "operations" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "dataExport", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.toDataExport()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataExport")))]
                )
              ],
              1
            ),
            _c(
              "template",
              { slot: "searchAreaHeader" },
              [_vm._t("searchAreaHeader")],
              2
            )
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              ref: "gridDetail",
              attrs: {
                "export-file-name": _vm.$t("AdvancePayment.BalanceDetail"),
                "config-module": _vm.gridConfigModule,
                "per-config-name": _vm.perConfigName,
                "refresh-id": _vm.gridRefreshId,
                "grid-params": _vm.gridParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData,
                "min-height": "350px"
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.gridParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.gridParams = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "pagination-wrapper",
            attrs: { id: "footer-wrapper-tab-detail" }
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.appendQuery,
                    expression: "appendQuery"
                  }
                ],
                staticClass: "pagination-container"
              },
              [
                _c("el-pagination", {
                  staticStyle: { "text-align": "left" },
                  attrs: { total: _vm.searchConditions.total, layout: "total" }
                })
              ],
              1
            ),
            _c("cargo-pagination", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.appendQuery,
                  expression: "!appendQuery"
                }
              ],
              ref: "paginationDetail",
              attrs: {
                "config-module": _vm.gridConfigModule,
                total: _vm.searchConditions.total,
                page: _vm.searchConditions.pageNum,
                limit: _vm.searchConditions.pageSize
              },
              on: {
                "update:page": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageNum", $event)
                },
                "update:limit": function($event) {
                  return _vm.$set(_vm.searchConditions, "pageSize", $event)
                },
                pagination: _vm.fetchDataByPage
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }